import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Variables } from "../../Variables1/Variables";
import validator from "validator";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Row, Col, Image, Form, Button, Spinner } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Link } from "react-router-dom";
import CustomSnipper from "../../components/customSnipper";
import Util from "../../Classes/Util";
import Cookies from "js-cookie";

function ManageAuthor(props) {
  const AuthorRouteId = useParams();
  const navigate = useNavigate();
  const token = Cookies.get("token");
  const [Permissions, setPermissions] = useState(
    Util.decrypt(localStorage.getItem("rpmRRTLx12"))
  );

  const [authorId, setAuthorId] = useState(
    Number(AuthorRouteId.AuthorRouteId) || 0
  );

  const [authorDetails, setAuthorDetails] = useState({
    AuthorId: 0,
    FirstName: "",
    LastName: "",
    GenderId: 1,
    AuthorPositionId: 1,
    PhoneNumber: "",
    Email: "",
    FacebookUrl: "",
    InstaUrl: "",
    LinkedInUrl: "",
  });

  const [genders, setGenders] = useState([]);
  const [positions, setPositions] = useState([]);

  const [loader, setLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  // Get Gender
  const GetGenders = async () => {
    let response = await fetch(Variables.API_URL + "Gender/GetGender", {
      method: "GET",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    let result = await response.json();
    if (response.status === 200) {
      setGenders(result);
    }
  };

  // Get Positions
  const GetPositions = async () => {
    let response = await fetch(
      Variables.API_URL + "AuthorPosition/GetAuthorPositions",
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      setPositions(result);
    }
  };

  // Get author details
  const GetAuthorDetails = async () => {
    let response = await fetch(
      Variables.API_URL + "Author/GetAuthorDetails/" + authorId,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    );
    let result = await response.json();
    if (response.status === 200) {
      setAuthorDetails(result);
    }
  };

  // handle Inputs
  const handleInputs = (e) => {
    const { name, value } = e.target;
    var element;
    if (value === "" || value === "0") {
      element = document.getElementById(name);
      element.classList.add("is-invalid");
    } else {
      element = document.getElementById(name);
      element.classList.remove("is-invalid");
    }
    setAuthorDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // handle Social Inputs
  const handleSocialMediaInputs = (e) => {
    const { name, value } = e.target;
    setAuthorDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Check input validity
  function IsValid() {
    var hasError = false;
    var element;
    if (authorDetails.FirstName === null || authorDetails.FirstName === "") {
      element = document.getElementById("FirstName");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (authorDetails.LastName === null || authorDetails.LastName === "") {
      element = document.getElementById("LastName");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (authorDetails.GenderId === null || authorDetails.GenderId === 0) {
      element = document.getElementById("GenderId");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (
      authorDetails.AuthorPositionId === null ||
      authorDetails.AuthorPositionId === 0
    ) {
      element = document.getElementById("AuthorPositionId");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (
      authorDetails.PhoneNumber === null ||
      authorDetails.PhoneNumber === ""
    ) {
      element = document.getElementById("PhoneNumber");
      element.classList.add("is-invalid");
      hasError = true;
    }
    if (
      authorDetails.Email === null ||
      authorDetails.Email === "" ||
      validator.isEmail(authorDetails.Email) === false
    ) {
      element = document.getElementById("Email");
      element.classList.add("is-invalid");
      hasError = true;
    }

    if (hasError === true) {
      return false;
    } else {
      return true;
    }
  }

  // Add new Author
  const AddNewAuthor = async () => {
    setButtonLoader(true);
    let response = await fetch(Variables.API_URL + "Author/AddNewAuthor", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        AuthorId: 0,
        FirstName: authorDetails.FirstName,
        LastName: authorDetails.LastName,
        GenderId: authorDetails.GenderId,
        AuthorPositionId: authorDetails.AuthorPositionId,
        PhoneNumber: authorDetails.PhoneNumber,
        Email: authorDetails.Email,
        FacebookUrl: authorDetails.FacebookUrl,
        InstaUrl: authorDetails.InstaUrl,
        LinkedInUrl: authorDetails.LinkedInUrl,
      }),
    });
    let result = await response.json();
    if (response.status === 200) {
      toast.success(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      setTimeout(() => {
        navigate("/Author");
      }, 1000);
    } else {
      toast.error(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    setButtonLoader(false);
  };

  // Update Author
  const UpdateAuthor = async () => {
    setButtonLoader(true);
    let response = await fetch(Variables.API_URL + "Author/UpdateAuthor", {
      method: "POST",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        AuthorId: authorId,
        FirstName: authorDetails.FirstName,
        LastName: authorDetails.LastName,
        GenderId: authorDetails.GenderId,
        AuthorPositionId: authorDetails.AuthorPositionId,
        PhoneNumber: authorDetails.PhoneNumber,
        Email: authorDetails.Email,
        FacebookUrl: authorDetails.FacebookUrl,
        InstaUrl: authorDetails.InstaUrl,
        LinkedInUrl: authorDetails.LinkedInUrl,
      }),
    });
    let result = await response.json();
    if (response.status === 200) {
      toast.success(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    } else {
      toast.error(result, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
    setButtonLoader(false);
  };

  // handle submit
  const HandleSubmit = () => {
    var isValid = IsValid();
    if (isValid) {
      // case of insert
      if (authorId === 0) {
        AddNewAuthor();
      }
      // case of update
      else {
        UpdateAuthor();
      }
    } else {
      toast.error("Please fill all required fields", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }
  };

  useEffect(() => {
  
      
    
    GetGenders();
    GetPositions();
    if (authorId != 0) {
      GetAuthorDetails();
    }
  }, []);


  return (
    <div>
      <Row>
        <Col xl="12" lg="12">
          <Card>
            <Card.Header className="d-flex justify-content-between">
              <div className="header-title">
                <h4 className="card-title">
                  {authorId === 0
                    ? "New User Author"
                    : "Update Author Information"}
                </h4>
              </div>
            </Card.Header>
            {loader === true ? <CustomSnipper /> : ""}
            <Card.Body>
              <div className="new-user-info">
                <form>
                  <div className="row">
                    <Form.Group className="col-md-6 form-group">
                      <Form.Label htmlFor="fname">First Name:</Form.Label>
                      <Form.Control
                        id="FirstName"
                        name="FirstName"
                        placeholder="First Name"
                        type="text"
                        value={authorDetails.FirstName}
                        onChange={handleInputs}
                      />
                    </Form.Group>

                    <Form.Group className="col-md-6 form-group">
                      <Form.Label htmlFor="lname">Last Name:</Form.Label>
                      <Form.Control
                        id="LastName"
                        name="LastName"
                        placeholder="Last Name"
                        type="text"
                        value={authorDetails.LastName}
                        onChange={handleInputs}
                      />
                    </Form.Group>

                    <Form.Group className="col-sm-6 form-group">
                      <Form.Label>Gender:</Form.Label>
                      <select
                        className="selectpicker form-control"
                        data-style="py-0"
                        name="GenderId"
                        id="GenderId"
                        value={authorDetails.GenderId}
                        onChange={handleInputs}
                      >
                        <option key={0} value={0}>
                          -- Select --
                        </option>
                        {genders.map((x) => {
                          return (
                            <option key={x.GenderId} value={x.GenderId}>
                              {x.GenderName}
                            </option>
                          );
                        })}
                      </select>
                    </Form.Group>

                    <Form.Group className="col-sm-6 form-group">
                      <Form.Label>Author Position:</Form.Label>
                      <select
                        className="selectpicker form-control"
                        data-style="py-0"
                        name="AuthorPositionId"
                        id="AuthorPositionId"
                        value={authorDetails.AuthorPositionId}
                        onChange={handleInputs}
                      >
                        <option key={0} value={0}>
                          -- Select --
                        </option>
                        {positions.map((x) => {
                          return (
                            <option
                              key={x.AuthorPositionId}
                              value={x.AuthorPositionId}
                            >
                              {x.AuthorPositionName}
                            </option>
                          );
                        })}
                      </select>
                    </Form.Group>

                    <Form.Group className="col-md-6  form-group">
                      <Form.Label htmlFor="email">Email:</Form.Label>
                      <Form.Control
                        id="Email"
                        name="Email"
                        placeholder="Email"
                        type="text"
                        value={authorDetails.Email}
                        onChange={handleInputs}
                      />
                    </Form.Group>

                    <Form.Group className="col-md-6  form-group">
                      <Form.Label htmlFor="mobno">Phone Number:</Form.Label>
                      <Form.Control
                        id="PhoneNumber"
                        name="PhoneNumber"
                        placeholder="Phone Number"
                        type="text"
                        value={authorDetails.PhoneNumber}
                        onChange={handleInputs}
                      />
                    </Form.Group>

                    <Form.Group className="col-md-6  form-group">
                      <Form.Label htmlFor="mobno">Facebook Url:</Form.Label>
                      <Form.Control
                        id="FacebookUrl"
                        name="FacebookUrl"
                        placeholder="Facebook Url"
                        type="text"
                        value={authorDetails.FacebookUrl}
                        onChange={handleSocialMediaInputs}
                      />
                    </Form.Group>

                    <Form.Group className="col-md-6  form-group">
                      <Form.Label htmlFor="mobno">Insta Url:</Form.Label>
                      <Form.Control
                        id="InstaUrl"
                        name="InstaUrl"
                        placeholder="Insta Url"
                        type="text"
                        value={authorDetails.InstaUrl}
                        onChange={handleSocialMediaInputs}
                      />
                    </Form.Group>

                    <Form.Group className="col-md-6  form-group">
                      <Form.Label htmlFor="mobno">LinkedIn Url:</Form.Label>
                      <Form.Control
                        id="LinkedInUrl"
                        name="LinkedInUrl"
                        placeholder="LinkedIn Url"
                        type="text"
                        value={authorDetails.LinkedInUrl}
                        onChange={handleSocialMediaInputs}
                      />
                    </Form.Group>
                  </div>
                </form>
              </div>
              <Row>
                <Col>
                  <Button
                    type="button"
                    variant="btn btn-primary"
                    className="float-right"
                    onClick={HandleSubmit}
                  >
                    {buttonLoader === true ? (
                      <>
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                        <span className="visually-hidden">Loading...</span>
                      </>
                    ) : authorId === 0 ? (
                      "Add New Author"
                    ) : (
                      "Update Author"
                    )}
                  </Button>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      <ToastContainer
        position="top-right"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default ManageAuthor;
